import { z } from 'zod';

export const WorkstreamDefinitionUserSchema = z.object({
    userId: z.number(),
    identifier: z.string()
});
export type WorkstreamDefinitionUser = z.infer<typeof WorkstreamDefinitionUserSchema>;
